import { Icon } from "./Icon.tsx";

/** "Add Subcatchment" tool icon — a drawn outline with a plus badge, same "shape + plus" convention as AddJunctionIcon/AddConduitIcon. */
export function AddSubcatchmentIcon() {
  return (
    <Icon>
      <path d="M2 20l1-9 6-2 5 3v8z" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
